import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Hero } from "../components/Hero";
import { ProductCard } from "../components/ProductCard";
import { SEO } from "../components/SEO";
import {
  FeaturedCategories, WhyChoose, Industries, Testimonials, TradeAccountCTA, SectionHead,
} from "../components/HomeSections";
import { getCollection } from "../lib/api";

const ProductRow = ({ eyebrow, title, kind, testid }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { getCollection(kind, 8).then(setItems).catch(() => {}); }, [kind]);
  return (
    <section data-testid={testid} className="py-20 md:py-28 bg-vr-bg">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <SectionHead eyebrow={eyebrow} title={title} cta={{ to: "/category/food-service", label: "Shop food service" }} />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {items.map((p, i) => <ProductCard key={p.sku} p={p} index={i} />)}
        </div>
      </div>
    </section>
  );
};

export default function Home() {
  return (
    <main data-testid="home-page">
      <SEO
        title="VR Packaging & Hygiene — Wholesale Packaging Supplies NZ"
        description="Wholesale packaging, hygiene, cleaning and safety supplies for New Zealand businesses. 1,700+ SKUs, trade pricing, nationwide dispatch."
        path="/"
      />
      <Hero />
      <FeaturedCategories />
      <ProductRow eyebrow="Popular now" title="Best selling products" kind="bestsellers" testid="bestsellers-section" />
      <Industries />
      <WhyChoose />
      <Testimonials />
      <section data-testid="latest-section" className="bg-vr-bg2">
        <div className="py-2" />
      </section>
      <ProductRowAlt />
      <TradeAccountCTA />
    </main>
  );
}

const ProductRowAlt = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { getCollection("latest", 8).then(setItems).catch(() => {}); }, []);
  return (
    <section data-testid="latest-products-section" className="py-20 md:py-28 bg-vr-bg2">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <SectionHead eyebrow="Just added" title="Latest products" cta={{ to: "/products", label: "View all products" }} />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {items.map((p, i) => <ProductCard key={p.sku} p={p} index={i} />)}
        </div>
      </div>
    </section>
  );
};
